<template>
  <vbt-badge
    v-if="showStatusBadge"
    :color="color"
    small
  >
    <slot />
  </vbt-badge>
  <span v-else>
    -
  </span>
</template>

<script>
export default {
  name: 'UmsStatusBadge',
  props: {
    // Must return color string
    colorResolver: {
      type: Function,
      default: null,
    },
    status: {
      type: [Number, String, Boolean],
      default: null,
    },
  },
  computed: {
    showStatusBadge() {
      return typeof this.status === 'boolean' ? true : Boolean(this.status);
    },
    color() {
      if (this.colorResolver) {
        return this.colorResolver(this.status);
      }

      if (typeof this.status === 'boolean') {
        return this.status ? 'success' : 'error';
      }

      if (this.status >= 1 && this.status <= 99) {
        return 'success';
      }
      if (this.status >= 100 && this.status <= 199) {
        return 'info';
      }
      if (this.status >= 200 && this.status <= 299) {
        return 'warning';
      }
      if (this.status >= 300 && this.status <= 399) {
        return 'error';
      }
      return 'default';
    },
  },
};
</script>
